import React from "react";
import Modal from "../../modal";

class ConfirmModal extends React.Component {
    onOk = () => {
        if (this.props.onOk) this.props.onOk();
    }

    onCancel = () => {
        if (this.props.onCancel) this.props.onCancel();
    }

    render() {
        return (
            <Modal
                {...this.props}
                show={this.props.show}
                title={this.props.title}
                size={this.props.size || "md"}
                buttons={[
                    { caption: "ok", onEnabledClick: this.onOk, variant: "primary", enabled: true, display: true },
                    { default: true, caption: "cancel", onEnabledClick: this.onCancel, variant: "primary", enabled: true, display: true },
                ]}
            >
            </Modal>
        )
    }
}

export default ConfirmModal;
